export const id = {
  welcome: 'Selamat datang',
  logout: 'Keluar',
  settings: 'Pengaturan',

  days: ['Minggu', 'Senin', 'Selasa', 'Rabu', 'Kamis', 'Jumat', 'Sabtu'],
  today: 'Hari ini',
  yesterday: 'Kemarin',

  THEME: {
    DARK: 'Gelap',
    LIGHT: 'Terang',
  },

  PLACEHOLDER: {
    SEARCH_PLACEHOLDER: 'Cari...',
    SELECT_OPTION: 'Pilih opsi...',
    SELECT_STATUS: 'Pilih status...',
    CHOOSE_STATUS: 'Pilih status...',
    LOCATION: 'Masukkan kota, alamat, atau tempat...',
    DESCRIPTION: 'Deskripsi insiden',
    AI_DESCRIPTION:
      'Jelaskan apa yang terjadi, di mana, dan kapan — contoh: Terjadi kebakaran kecil di ruang listrik dekat Balestier Road, Novena.',
    LOCATION_DESCRIPTION: 'Detail tambahan tentang lokasi',
    VALIDATING: 'Memvalidasi...',
    GENERATING: 'Menghasilkan...',
  },

  CHAT_PANEL: {
    SEARCH_PLACEHOLDER: 'Cari...',
    NO_MESSAGES_YET: 'Belum ada pesan',
    IS_SPEAKING: 'sedang berbicara...',
    ONLINE: 'online',
    OFFLINE: 'offline',
    TRANSCRIBING: 'Transkripsi...',
    NO_CHAT_FOUND: 'Tidak ada chat yang ditemukan',
    NO_CHAT_SELECTED_TITLE: 'Tidak ada chat yang dipilih',
    NO_CHAT_SELECTED_DESCRIPTION: 'Pilih pengguna atau grup dari sidebar untuk mulai mengirim pesan',
    INPUT_PLACEHOLDER_DEFAULT: 'Ketik pesan...',
    INPUT_PLACEHOLDER_WITH_ATTACHMENT: 'Tambahkan keterangan...',
    IS_TALKING: 'sedang bicara...',
    PTT_ACTIVE: 'PTT Aktif – Sedang berbicara...',
    PTT_LOCKED: 'PTT Terkunci – Klik untuk melepaskan',
    PTT_SLIDE_HINT: 'Geser ke atas untuk mengunci',
    PTT_RELEASE_AND_SEND: 'Lepaskan & Kirim',
    ATTACHED_FILES_TITLE: 'Berkas Terlampir',
    FAILED_TO_TRANSCRIBE_AUDIO: 'Gagal menyalin audio',
    NO_CHAT_MESSAGE: 'Tidak ada pesan chat',
    FALLBACK_MESSAGE: 'Untuk memulai chat, ketik pesan Anda atau gunakan fitur PTT/PTV.',
    INCOMING_VIDEO_CALL: 'PTV masuk...',
    SOMETHING_WENT_WRONG: 'Terjadi kesalahan',
    ERROR: 'Kesalahan:',
    NO_MESSAGES_FOUND_FOR: 'Tidak ada pesan ditemukan untuk',
    SYSTEM_MESSAGE: 'Pesan sistem',
    GROUP: 'grup',
    AUDIO: 'audio',
    VIDEO: 'video',
    FILE: 'file',
    ME: 'saya',
    IMAGE: 'gambar',
    TEXT: 'teks',
    CHAT: 'chat',
    NONE: 'tidak ada',
    PROFILE: 'profil',
    SEARCH: 'cari',
    COMPLETED: 'selesai',
    RESOLVED: 'teratasi',
    USER_EMAIL_DOMAIN: '@widebridgecloud.com',
    UNKNOWN: 'Tidak diketahui',
    THEM: 'mereka',
    HAS_ACCEPTED_THE_INCIDENT: 'telah menerima insiden',
    INCIDENT_HAS_BEEN_UPDATED: 'Insiden telah diperbarui',
    INCIDENT_HAS_BEEN_RESOLVED: 'Insiden telah diselesaikan',
    YOU_HAVE_JOINED_THE_GROUP: 'Anda telah bergabung dengan grup',
  },

  PROFILE_PANEL: {
    MEMBERS_LABEL: 'anggota',
    GROUP_MEMBERS_TITLE: 'Anggota Grup',
    USERNAME_LABEL: 'Nama Pengguna',
    EMAIL_LABEL: 'Email',
    MEMBER_FALLBACK_NAME: 'Anggota',
    MEMBER_FALLBACK_ID: 'Anggota',
  },

  PTT: {
    AUDIO: {
      FILENAME_PREFIX: 'ptt-audio-',
      FILE_TYPE: 'audio/webm',
      FILE_EXTENSION: '.webm',
    },
    MESSAGES: {
      START_RECORDING: 'Mulai merekam PTT untuk {{userName}}',
      STOP_RECORDING: 'Audio PTT dikirim ke {{userName}}',
      NO_AUDIO_DATA: 'Tidak ada data audio dari SDK',
      TRANSCRIPTION_SUCCESS: 'Transkripsi audio selesai',
      TRANSCRIPTION_FAILED: 'Transkripsi gagal, mengirim audio tanpa teks',
    },
    TRANSCRIPTION: {
      MODEL: 'whisper-1',
      LANGUAGE: 'id',
      RESPONSE_FORMAT: 'text',
    },
  },

  CHAT_WINDOW: {
    SEARCH_IN: 'Cari di',
    YOUR_PROFILE: 'Profil Anda',
    VIEW_PROFILE: 'Lihat profil',
    PIN_CHAT: 'Sematkan obrolan',
    UNPIN_CHAT: 'Lepas sematan obrolan',
    MUTE_CHAT: 'Bisukan obrolan',
    UNMUTE_CHAT: 'Bunyikan obrolan',
  },

  DASHBOARD: {
    INCIDENTS: 'insiden',
    INCIDENTS_NO_DATA: 'Untuk membuat insiden, klik tombol "+ Buat Insiden"',
    RESPONDERS: 'petugas tanggap',
    RESPONDERS_NO_DATA: 'Tidak ada petugas tanggap yang ditemukan.',
    CHAT: 'obrolan',
    ALERTS: 'peringatan',
    ALERTS_NO_DATA: 'Tidak ada peringatan yang dihasilkan oleh sistem.',
    UPDATES: 'pembaruan',
    UPDATES_NO_DATA: 'Belum ada pembaruan pada insiden atau petugas tanggap.',
    NEW_MESSAGE_FROM: 'Pesan baru dari',
    INCIDENT_UPDATED_BY: 'Insiden diperbarui oleh',
    NEW_INCIDENT_CREATED_BY: 'Insiden baru dibuat oleh',
    PROFILE: 'profil',
    SUMMARY: 'ringkasan',
    GENERATING_SUMMARY: 'sedang membuat ringkasan...',
  },

  INCIDENTS_PANEL: {
    INCIDENT_NAME: 'Nama insiden',
    INCIDENT_TYPE: 'Jenis insiden',
    ASSIGNEES: 'petugas yang ditugaskan',
    SEVERITY: 'tingkat keparahan',
    STATUS: 'status',
    STATUS_HISTORY: 'Riwayat Status',
    SHOW: 'Tampilkan',
    SHOW_LESS: 'Tampilkan lebih sedikit',
    MORE: 'lebih banyak',
    PTT: 'PTT',
    LOCATION: 'lokasi',
    SEVERITY_CRITICAL: 'kritis',
    SEVERITY_HIGH: 'tinggi',
    SEVERITY_MEDIUM: 'sedang',
    SEVERITY_LOW: 'rendah',
    SEVERITY_MINIMAL: 'minimal',
    REPORTED_DATE_TIME: 'Tanggal dan Waktu Dilaporkan',
    REPORTED_NAME: 'Nama Pelapor',
    DESCRIPTION: 'deskripsi',
    RESPONDERS: 'responden',
    ATTACHMENTS: 'lampiran',
    LOCATION_DESCRIPTION: 'deskripsi lokasi',
    NO_RESPONDERS_ASSIGNED: 'Tidak ada responden yang ditugaskan untuk insiden ini.',
    CREATE_INCIDENT: 'Buat Insiden',
    EDIT_INCIDENT: 'Edit Insiden',
    SELECT_RESPONDERS: 'Pilih Responden',
    COMPLETE: 'Selesai',
    CANCEL: 'Batal',
    SAVE: 'Simpan perubahan',
    NO: 'Tidak',
    DATA_FOUND: 'Data ditemukan',
    NO_OPTIONS: 'Tidak ada opsi tersedia',
    AI_ASSISTANCE: 'Bantuan AI',
  },

  TAB_KEYS: {
    ALL: 'Semua',
    UNREAD: 'Belum Dibaca',
    ACTIVE: 'Aktif',
    CLOSED: 'Ditutup',
    AVAILABLE: 'Tersedia',
    OFFLINE: 'Luring',
    TAB_VALUE_UNACKNOWLEDGED: 'Belum Dikonfirmasi',
    TAB_VALUE_CREATED: 'Dibuat',
    TAB_VALUE_PROGRESS: 'Sedang Diproses',
    TAB_VALUE_RESOLVED: 'Terselesaikan',
  },

  UPDATES_PANEL: {
    UPDATES: 'Pembaruan',
    MARK_AS_READ: 'Tandai semua sebagai sudah dibaca',
    ALL: 'Semua',
    UNREAD: 'Belum dibaca',
    ALL_KEY: 'all',
    UNREAD_KEY: 'unread',
    NO_NOTIFICATIONS: 'Tidak ada notifikasi',
    NO_UNREAD_NOTIFICATIONS: 'Tidak ada notifikasi yang belum dibaca',
    UPDATE_STATUS: 'Perbarui status:',

    // Notification titles
    NEW_INCIDENT_TITLE: 'Insiden Baru',
    UPDATE_TITLE: 'Pembaruan',

    CREATED_AT: 'dibuat pada',

    // Status labels
    STATUS_CLOSED: 'Ditutup',
    STATUS_IN_PROGRESS: 'Sedang Berlangsung',

    // Change descriptions
    STATUS_CHANGE: 'Status',
    SEVERITY_CHANGE: 'Tingkat Keparahan',
    TYPE_CHANGE: 'Tipe',
    DESCRIPTION_UPDATED: 'Deskripsi diperbarui',
    RESPONDERS_ADDED: 'responden ditambahkan',
    RESPONDERS_REMOVED: 'responden dihapus',
    RESPONDERS_UPDATED: 'Responden diperbarui',
    LOCATION_CHANGED: 'Lokasi berubah',
    UPDATED_DEFAULT: 'Diperbarui',

    //Time
    UNKNOWN: 'Tidak diketahui',
    JUST_NOW: 'baru saja',
    MINUTES_AGO: '{{count}} menit yang lalu',
    MINUTES_AGO_plural: '{{count}} menit yang lalu',
    HOURS_AGO: '{{count}} jam yang lalu',
    HOURS_AGO_plural: '{{count}} jam yang lalu',
    DAYS_AGO: '{{count}} hari yang lalu',
    DAYS_AGO_plural: '{{count}} hari yang lalu',

    // Default values
    DEFAULT_TYPE: 'Insiden',
    UNKNOWN_LOCATION: 'Lokasi tidak diketahui',
  },

  MAP_VIEW: {
    INCIDENT_TOOLTIP: {
      INCIDENTTYPE: 'Jenis Insiden',
      REPORTEDDATE: 'Tanggal Dilaporkan',
      SEVERITY: 'Tingkat Keparahan',
      STATUS: 'Status',
      RESPONDERS: 'Petugas Tanggap',
      NO_RESPONDERS: 'Tidak ada petugas yang tersedia',
    },
    INCIDENT_CLUSTER_TOOLTIP: {
      INCIDENTS: 'Insiden',
      MORE: 'lagi...',
    },
    MAP_FILTER: {
      VIEW_MODE: 'Mode Tampilan',
      DEFAULT: 'Default',
      SATELLITE: 'Satelit',
      FILTER_BY: 'Filter Berdasarkan',
      ALL: 'semua',
      ACTIVE: 'Aktif',
      COMPLETED: 'Selesai',
      RESPONDERS: 'Petugas Tanggap',
      AVAILABLE: 'tersedia',
    },
  },

  FALLBACK_SCREEN: {
    NO: 'Tidak',
    DATA_FOUND: 'Data Ditemukan',
    CREATE_INCIDENT: 'Buat Insiden',
    NO_AVAILABLE_RESPONDER_FOUND: 'Tidak ada petugas yang tersedia ditemukan',
  },
  PERMISSION_DIALOG: {
    MICROPHONE: {
      TITLE: 'Izin Mikrofon Diperlukan',
      DESCRIPTION: 'Aplikasi ini memerlukan akses ke mikrofon Anda agar berfungsi dengan baik.',
      INSTRUCTION: 'Silakan berikan izin mikrofon untuk melanjutkan penggunaan aplikasi.',
      BUTTON_LABEL: 'Berikan Izin Mikrofon',
    },
    CAMERA: {
      TITLE: 'Izin Kamera Diperlukan',
      DESCRIPTION: 'Aplikasi ini memerlukan akses ke kamera Anda agar berfungsi dengan baik.',
      INSTRUCTION: 'Silakan berikan izin kamera untuk melanjutkan penggunaan aplikasi.',
      BUTTON_LABEL: 'Berikan Izin Kamera',
    },
    NOTIFICATIONS: {
      TITLE: 'Izin Notifikasi Diperlukan',
      DESCRIPTION: 'Aplikasi ini memerlukan izin untuk mengirim notifikasi kepada Anda.',
      INSTRUCTION: 'Silakan berikan izin notifikasi untuk melanjutkan penggunaan aplikasi.',
      BUTTON_LABEL: 'Berikan Izin Notifikasi',
    },
    GEOLOCATION: {
      TITLE: 'Izin Lokasi Diperlukan',
      DESCRIPTION: 'Aplikasi ini memerlukan akses ke lokasi Anda agar berfungsi dengan baik.',
      INSTRUCTION: 'Silakan berikan izin lokasi untuk melanjutkan penggunaan aplikasi.',
      BUTTON_LABEL: 'Berikan Izin Lokasi',
    },
    HEADINGS: {
      WHAT_TO_DO: 'Apa yang perlu Anda lakukan:',
      ADDITIONAL_REQUIRED: 'Izin tambahan diperlukan',
      GENERIC_PERMISSION_TITLE: 'Izin Diperlukan',
      GENERIC_DESCRIPTION: 'Aplikasi ini memerlukan izin tambahan agar berfungsi dengan baik.',
      GENERIC_INSTRUCTION: 'Silakan berikan izin yang diperlukan untuk melanjutkan.',
    },
    DEFAULT_BUTTON_LABEL: 'Berikan Izin',
  },
  SETTINGS: {
    TITLE: 'Pengaturan',
    SUBTITLE: 'Kelola preferensi bahasa dan terjemahan Anda',
    LANGUAGE_DISPLAY: 'Bahasa Tampilan',
    AUTO_TRANSLATE_TITLE: 'Aktifkan Terjemahan Otomatis',
    AUTO_TRANSLATE_DESCRIPTION: 'Terjemahkan pesan yang masuk secara otomatis ke bahasa yang Anda pilih.',
    SAVE_BUTTON: 'Simpan',
    SELECT_PLACEHOLDER: 'Pilih opsi...',
  },

  SOS_MODAL: {
    TITLE_ALERT_TRIGGERED: 'Peringatan SOS diaktifkan',
    LOCATION_LABEL: 'Lokasi',
    INCIDENT_LABEL: 'Insiden',
    LAST_STATUS_LABEL: 'Status Terakhir',
    ASSIST_BUTTON: 'Bantu',
  },

  HEADER: {
    USERNAME: 'Nama pengguna',
    MODE: 'Mode',
    SETTINGS: 'Pengaturan',
    LOG_OUT: 'Keluar',
    TITLE: 'AGIL Field Ops',
  },

  ERRORS: {
    INVALID_CHAT_DATA: 'Data obrolan tidak valid',
    SUMMARY_GENERATION_FAILED: 'Gagal membuat ringkasan:',
    FAILED_TO_GENERATE_SUMMARY: 'Gagal membuat ringkasan.',
    PLEASE_TRY_AGAIN: 'Silakan coba lagi.',
    UNKNOWN: 'Tidak diketahui',
    IN_PROGRESS_STATUS_ERROR: 'Setidaknya satu penanggap harus ditugaskan saat status "Sedang diproses"',
    RESOLVED_STATUS_ERROR: 'Setidaknya satu penanggap harus ditugaskan sebelum menutup insiden',
    SELECT_ONE_RESPONDER_ERROR: 'Silakan pilih setidaknya satu penanggap',
    WAIT_BEFORE_SUBMIT_AGAIN: 'Silakan tunggu sebelum mengirim lagi',
    INCIDENT_CREATION_SERVICE_UNAVAILABLE: 'Layanan pembuatan insiden tidak tersedia. Silakan coba lagi nanti.',
    NO_CHANGES_TO_UPDATE: 'Tidak ada perubahan untuk diperbarui',
    FAILED_TO_UPDATE_INCIDENT: 'Gagal memperbarui insiden. Periksa koneksi Anda dan coba lagi.',
    FAILED_TO_CREATE_INCIDENT: 'Gagal membuat insiden. Periksa koneksi Anda dan coba lagi.',
  },

  INCIDENT_TYPES: [
    { value: 'Medical', label: 'Medis' },
    { value: 'Car accident', label: 'Kecelakaan mobil' },
    { value: 'Fire', label: 'Kebakaran' },
    { value: 'Patrol', label: 'Patroli' },
  ],

  SEVERITY_VALUES: [
    { value: 4, label: 'Kritis', dotColor: 'bg-icon-error' },
    { value: 3, label: 'Tinggi', dotColor: 'bg-chart-2' },
    { value: 2, label: 'Sedang', dotColor: 'bg-chart-4' },
    { value: 1, label: 'Rendah', dotColor: 'bg-interactive' },
    { value: 0, label: 'Minimal', dotColor: 'bg-icon-muted' },
  ],

  INCIDENT_CARD_STATUS_VALUES: [
    { value: 'created', label: 'Dibuat' },
    { value: 'progress', label: 'Sedang diproses' },
    { value: 'resolved', label: 'Terselesaikan' },
  ],

  CREATE_INCIDENT_STATUS_VALUES: [
    { value: 'open', label: 'Dibuat' },
    { value: 'in_progress', label: 'Sedang diproses', disabled: false },
  ],

  EDIT_INCIDENT_STATUS_VALUES: [
    { value: 'in_progress', label: 'Sedang diproses' },
    { value: 'resolved', label: 'Ditutup' },
  ],

  INCIDENT_DETAILS_STATUS_VALUES: [
    { value: 'created', label: 'Dibuat', disabled: true },
    { value: 'progress', label: 'Sedang diproses', disabled: true },
    { value: 'resolved', label: 'Ditutup', disabled: true },
  ],

  RESPONSE_STATUS: [
    { value: 'accepted', label: 'Diterima' },
    { value: 'rejected', label: 'Ditolak' },
    { value: 'pending', label: 'Tertunda' },
  ],

  ASSIGNEE_STATUS: [
    { value: 'not_started', label: 'Belum dimulai' },
    { value: 'on_the_way', label: 'Dalam perjalanan' },
    { value: 'reach_site', label: 'Tiba di lokasi' },
    { value: 'enroute', label: 'Dalam perjalanan' },
    { value: 'done', label: 'Selesai' },
  ],

  RESPONDER_STATUS: [
    { value: 'Unacknowledged', label: 'Belum diakui' },
    { value: 'Rejected', label: 'Ditolak' },
    { value: 'Arrived at scene', label: 'Tiba di lokasi' },
    { value: 'On the way', label: 'Sedang dalam perjalanan' },
    { value: 'Aborted', label: 'Dibatalkan' },
    { value: 'Done', label: 'Selesai' },
  ],

  WEEKDAYS: [
    { value: 'Sun', label: 'Min' },
    { value: 'Mon', label: 'Sen' },
    { value: 'Tue', label: 'Sel' },
    { value: 'Wed', label: 'Rab' },
    { value: 'Thu', label: 'Kam' },
    { value: 'Fri', label: 'Jum' },
    { value: 'Sat', label: 'Sab' },
  ],
};
